import { css } from '@emotion/react'
import { Cell, Flow, Grid, Heading, Modal, ModalBody, ModalHeader, Text, Theme, useTheme } from 'bold-ui'

import { ListaTematicaInformacaoAccordion } from './ListaTematicaInformacaoAccordion'

interface ListaTematicaInformacaoModalLegacyProps {
  isModalOpen: boolean
  setIsModalOpen(isModalOpen: boolean): void
}

export function ListaTematicaInformacaoModalLegacy(props: Readonly<ListaTematicaInformacaoModalLegacyProps>) {
  const { isModalOpen, setIsModalOpen } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  const handleClose = () => {
    setIsModalOpen(false)
  }

  return (
    <Modal open={isModalOpen} size='auto' onClose={handleClose} closeOnBackdropClick style={styles.modal}>
      <ModalHeader title='Saiba mais' icon={{ name: 'infoCircleOutline', fill: 'primary' }} />
      <ModalBody>
        <Flow direction='vertical'>
          <Flow direction='vertical' gap={1.5}>
            <Text>
              Por padrão, as listas temáticas apresentam pessoas que se enquadram nos critérios de seleção, entretanto,
              os filtros podem ser alterados de acordo com a necessidade do usuário.
            </Text>
            <Text>Os dados específicos foram construídos a partir das mais recentes boas práticas em saúde.</Text>
            <Text>Abaixo é possível visualizar a origem dos dados detalhadamente:</Text>
          </Flow>
          <Flow direction='vertical'>
            <Grid>
              <Cell key='marcoSection' lg={12} md={12}>
                <div css={styles.headerAccordion}>
                  <Heading level={5}>Origem dos dados</Heading>
                </div>
                <ListaTematicaInformacaoAccordion />
              </Cell>
            </Grid>
          </Flow>
        </Flow>
      </ModalBody>
    </Modal>
  )
}

const createStyles = (theme: Theme) => ({
  modal: css`
    width: 48rem;
    max-width: 62rem;
    display: flex;
    flex-direction: column;
  `,
  headerAccordion: css`
    background-color: ${theme.pallete.gray.c90};
    padding: 0.55rem 0.7rem;
    border: 1px ${theme.pallete.divider} solid;
    border-bottom: 0;
    border-radius: ${theme.radius.input}px ${theme.radius.input}px 0 0;
  `,
})
